import {all} from 'country-codes-list';

// List of EU country codes
const euCountries = [
    'LT',
    'LV',
    'EE',
];

// Function to get EU countries and sort them by calling code
export const getEUPhoneCountries = () => {
    return all()
        .filter(c => euCountries.includes(c.countryCode)) // Filter for EU countries only
        .sort((a, b) => parseInt(a.countryCallingCode) - parseInt(b.countryCallingCode)); // Sort by calling code
};
